<template>
  <div :style="iconStyle" class="d-flex flex-column justify-content-center align-items-center">
    <i class="far fa-chart-bar icon_table"></i>
    <div class="text_table" v-text="text"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, default: "Texto sin asignar" },
    sizeText: { type: String, default: "1.1rem"},
    sizeIcon: { type: String, default: "6rem"}
  },
  computed: {
    iconStyle() {
      return {
        "--sizeText": this.sizeText,
        "--sizeIcon": this.sizeIcon
      };
    },
  },
};
</script>

<style>
.text_table {
  font-size: var(--sizeText);
  font-weight: 600;
  color: #bfbfbf;
}
.icon_table {
  color: #bfbfbf;
  font-size: var(--sizeIcon);
}
</style>
